import React from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import EventCalender from "../components/dashboard/EventCalender";
import Strings from "../constants/Strings";

const EventCalendar = () => {
  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10 main_content_right_side"
          style={{
            minHeight: "100vh",
            paddingLeft: "32px",
            paddingRight: "30px",
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div className="main-section dashboard" style={{ marginTop: 105 }}>
            <div>
              <p
                style={{
                  position: "relative",
                  fontSize: 32,
                  fontFamily: "Open Sans",
                  fontWeight: "bold",
                  color: "#1A4F83",
                  textAlign: "start",
                }}
                className="mb-4 mt-4"
              >
                {Strings.eventCalender}
              </p>
              <div
                className="p-2 mb-4"
                style={{ background: "#fff", overflowX: "scroll" }}
              >
                <EventCalender />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EventCalendar;
